// services/WorkspaceTeam.js
import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";
import qs from "qs";

export default class WorkspaceTeam extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "team";
    static pluralName = "teams";
    static displayName = "WorkspaceTeam";

    constructor() {
        super(`${WorkspaceTeam.kind}`,`${WorkspaceTeam.singularName}`,`${WorkspaceTeam.pluralName}`);}

    async getAll(query = {}) {
        const qs = require('qs');
        const _query = qs.stringify({...query}, {
            encodeValuesOnly: true, // prettify URL
        });

        return await this.fetch(_query);
    }


    async getById(id, query = {}) {
        return await this.find(id, { populate: "*", ...query });
    }

    async createItem(data) {
        return await this.create(data);
    }

    async updateItem(id, data) {
        return await this.update(id, data);
    }

    async deleteItem(id) {
        return await this.delete(id);
    }
}
